import { FC, useEffect } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { useSkyViewStore } from "~/features/skyView/store";
import { useTourStore } from "../../store/useTourStore";
import { Tour } from "../Tour";

export const SkyViewTour: FC = () => {
  const { data: user } = useGetCurrentUser();
  const setExpanded = useSkyViewStore((state) => state.setExpanded);
  const isTourCompleted = useTourStore((state) => state.isTourCompleted);

  const shouldShowTour = user?.hasCompletedFtue && !isTourCompleted("skyView");

  useEffect(() => {
    if (shouldShowTour) {
      setExpanded(true);
    }
  }, [shouldShowTour, setExpanded]);

  return <Tour tourId="skyView" enabled={shouldShowTour} />;
};
